var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"TableExpander",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggle.apply(null, arguments)}}},[_c('i',{class:'fa fa-fw ' + _vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }